import { withRouter } from "react-router";
import { compose, withHandlers, withProps } from "recompose";
import { withOverlay, withSnackbar } from "@dpdgroupuk/mydpd-ui";
import { COL, DEL } from "./constants";
import { QueryUtil } from "../../utils";
import { withAppContext } from "../../Context";
import { PROJECT_NAME } from "../../constants";
import Search from "../../components/Search";
export default compose(withRouter, withSnackbar, withOverlay, withAppContext, withProps(({
  appContext
}) => ({
  searchType: appContext.projectName === PROJECT_NAME.COLLECTIONS ? COL : DEL
})), withHandlers({
  onSubmit: ({
    overlay,
    snackbar,
    appContext
  }) => async ({
    searchType,
    searchText
  }) => {
    if (!searchText) return;
    const {
      urlResolver,
      apis
    } = appContext;
    const query = {};

    if (searchType === DEL) {
      query.searchParam = searchText;
    } else if (searchType === COL) {
      query.reference = searchText;
    }

    if (searchType === COL) {
      try {
        overlay.show();
        const {
          data
        } = await apis.reference.searchCollections(query);
        const {
          collectionCodes
        } = data;

        if (collectionCodes.length === 1) {
          window.location.href = `${urlResolver.getUrl(PROJECT_NAME.COLLECTIONS)}/collections/${collectionCodes[0]}`;
        } else {
          window.location.href = `${urlResolver.getUrl(PROJECT_NAME.COLLECTIONS)}/collections?${QueryUtil.stringifyQuery(query, true)}`;
        }

        overlay.hide();
      } catch (e) {
        overlay.hide();
        snackbar.showAlert({
          message: "Reference not found"
        });
      }
    } else if (searchType === DEL) {
      try {
        overlay.show();
        const {
          data
        } = await apis.reference.searchParcels(query);

        if (data.parcelCodes.length === 1) {
          window.location.href = `${urlResolver.getUrl(PROJECT_NAME.DELIVERIES)}/parcels/${data.parcelCodes[0]}`;
        } else {
          window.location.href = `${urlResolver.getUrl(PROJECT_NAME.DELIVERIES)}/parcels?${QueryUtil.stringifyQuery(query, true)}`;
        }

        overlay.hide();
      } catch (e) {
        overlay.hide();
        snackbar.showAlert({
          message: "Reference not found"
        });
      }
    }
  }
}))(Search);